export { default } from "./TextTopic";
